import React from "react"

import styles from "./index.module.css"

type Props = {
  onClick: (index: number) => void
  anchors: string[]
}

export const Anchors: React.FC<Props> = ({ onClick, anchors }) => {
  const handleClick = (i: number): void => {
    onClick(i)
  }

  return (
    <div className={styles.Wrapper}>
      <div className={styles.Title}>Содержание</div>

      <ul className={styles.List}>
        {anchors.map((anchor, i) => (
          <li key={anchor}>
            <div
              dangerouslySetInnerHTML={{ __html: anchor }}
              className={styles.Anchor}
              onClick={() => handleClick(i)}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}
